import AddressDTO from "@/dto/AddressDTO";
import {FillableDocumentStatus} from "@/dto/archive/FillableDocumentStatus";

export enum FilingStatus {
    SINGLE_OR_MARRIED_SEPARATELY = "SINGLE_OR_MARRIED_SEPARATELY",
    MARRIED_OR_WIDOW = "MARRIED_OR_WIDOW",
    HEAD_OF_HOUSEHOLD = "HEAD_OF_HOUSEHOLD",
}

export class FillW4Request {
    // Step 0: Personal Info
    firstName!: string;
    lastName!: string;
    localAddress = new AddressDTO();
    ssn!: string;

    // Step 1: Filing Status
    filingStatus?: FilingStatus;

    // Step 2: Multiple Jobs
    hasTwoJobs?: boolean;
    hasThreeJobs?: boolean;
    incomeTwoJobs?: number;
    incomeThreeJobsA?: number;
    incomeThreeJobsB?: number;
    incomeThreeJobsC?: number;
    numberOfPeriod?: number;
    divide?: number;

    // Step 3: Claim Dependents and Other Credits
    qualifyingChildrenUnder17?: number;
    otherDependents?: number;
    otherAmount?: number;

    // Step 4: Other Adjustments
    otherIncome?: number;
    deductions?: number;
    extraWithholding?: number;

    // Tax exemption
    taxExempted?: boolean;

    constructor(init?: Partial<FillW4Request | SaveW4RequestDTO>) {
        Object.assign(this, init);
    }
}

export default class SaveW4RequestDTO {

    public id: number | null = null;
    public publicId = "";
    public status: FillableDocumentStatus | null = null;
    public sublimeFilling: boolean | null = null;
    public signerPublicId: string | null = null;
    public firstName = "";
    public lastName = "";
    public localAddress = new AddressDTO()
    public employeeSsn = "";
    public isSingleMarriedSeparately = true;
    public isMarriedOrWidow = false;
    public isHeadOfHousehold = false;
    public is2Jobs = false;
    public pieceChildrenUnderSeventeenOn2000: number | null = null;
    public pieceOtherDependentsOn500: number | null = null;
    public otherAmount: number | null = null;
    public otherIncome: number | null = null;
    public deductions: number | null = null;
    public extraWithholding: number | null = null;
    public incomeTwoJobs: number | null = null;
    public incomeThreeJobsA: number | null = null;
    public incomeThreeJobsB: number | null = null;
    public incomeThreeJobsC: number | null = null;
    public numberOfPeriod: number | null = null;
    public divide: number | null = null;
    public estimateOfDeductions: number | null = null;
    public estimate: number | null = null;
    public differenceOfEstimates: number | null = null;
    public estimateOfStudent: number | null = null;
    public sumOfEstimate: number | null = null;

    public merge(obj: SaveW4RequestDTO) {
        if (obj.firstName) {
            this.firstName = obj.firstName;
        }
        if (obj.lastName) {
            this.lastName = obj.lastName;
        }
        if (obj.employeeSsn) {
            this.employeeSsn = obj.employeeSsn;
        }
        if (obj.localAddress) {
            this.localAddress = obj.localAddress;
        }
    }

}



export class Address {

    public address = "";

    public city = "";

    public state = "";

    public zipCode: number | null = null;

}
